import picRouter from './pic.router';
import pedidoVendas from './pedidoVendas.router';
import pedidosVendasPadrao from './pedidoVendasPadrao.router';
import devolucoesRouter from './devolucoes.router';
import devolucaoSaldoRouter from './devolucaoSaldo.router';

export default [
  ...picRouter,
  ...pedidoVendas,
  ...pedidosVendasPadrao,
  ...devolucoesRouter,
  ...devolucaoSaldoRouter,
];
